module.exports = __webpack_public_path__ + "img/default-avatar.f3c9a7ac.svg";